import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { debounce } from 'lodash';
import { UserListToolbar } from 'src/sections/@dashboard/user';
import EnhancedTableRow from '../TableSelectedUser/EnhancedTableRow';
import {
    Box,
    Card,
    Stack,
    Button,
    TableRow,
    TableCell,
    Container,
    Typography,
    IconButton,
    TableHead,
    CircularProgress,
    Paper,
    TablePagination,
    TableContainer,
    TableBody,
    Table,
} from '@mui/material';
import Loader from 'src/components/loader/loader';
import crypt from 'src/utils/service/crypt';

const TablePermissionUser = ({ valueGroupId, activeTable }) => {
    const { t } = useTranslation();

    const searchValueDeboun = useRef('');
    const throttled = useRef(debounce(() => getDataUser(), 1000));

    const [listUser, setListUser] = useState([]);
    const [getFlags, setGetFlags] = useState(false);
    const getRef = useRef(false);

    const arrFillters = useRef([]);
    const [total, setTotal] = useState(0);
    const lastID = useRef(0);

    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const addFlagsPermission = useRef(false);
    const [permissionFlags, setPermissionFlags] = useState(false);

    const [listUserPermission, setListUserPermission] = useState([]);
    const [getFlagsGroupPermissions, setGetFlagsGroupPermissions] = useState(false);
    const getRefGroupPermissions = useRef(false);

    const [tableDataGroupPermissions, setTableDataGroupPermissions] = useState([]);

    const [workStatusCount, setworkStatusCount] = useState(0);

    const screenPermissions = useRef({});
    const user = useRef({});

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
        const menu = sessionStorage.getItem('menu');
        if (menu) {
            try {
                const data = JSON.parse(crypt.deCode(menu));
                // console.log('Loading menu', data[0]);
                screenPermissions.current = data[0].filter((item) => item.screens_key === 'phan_quyen_nguoi_dung')[0];
                // console.log('screenPermissions', screenPermissions);
            } catch (error) {}
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            getDataUser();
        }, 600);
    }, []);

    const getDataUser = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const Inval = [0, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getListUserBase, Inval, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log('success: ', message.proc_data.rows[0].o_1, message.proc_data.rowTotal);
            setListUser(message.proc_data.rows[0].o_1);
            setTotal(message.proc_data.rowTotal);
            lastID.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
            arrFillters.current = message.proc_data.rows[0].o_1;
            if (searchValueDeboun.current) {
                setPage(0);
            }
            // console.log(lastID.current);
        }
    };

    const getDataNext = () => {
        if (getRef.current) {
            return;
        }
        setGetFlags(true);
        getRef.current = true;
        const InVal = [lastID.current, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getListUserBase, InVal, getDataResultNext, true, timeOutFunct, 40000);
    };

    const getDataResultNext = (reqInfoMap, message) => {
        setGetFlags(false);
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setListUser([...listUser, ...message.proc_data.rows[0].o_1]);
            setTotal(message.proc_data.rowTotal);
            if (message.proc_data.rows[0].o_1?.length > 0) {
                lastID.current = message.proc_data.rows[0].o_1?.at(-1)?.id;
                arrFillters.current = message.proc_data.rows[0].o_1;
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const searchValue = (value) => {
        if (!value) {
            value = '';
        }
        searchValueDeboun.current = value;
        // setvalueSearch(value);
        throttled.current();
    };

    const headCells = [
        {
            id: 'name_staff',
            numeric: false,
            disablePadding: true,
            label: t('name_staff'),
        },
        {
            id: 'name_department',
            numeric: false,
            disablePadding: false,
            label: t('name_department'),
        },
    ];

    const handleClick = (event, data) => {
        const selectedIndex = data;
        handlePermission(selectedIndex);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        getDataNext();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // const isSelected = (id) => selected.indexOf(id) !== -1;

    const handlePermission = (data) => {
        if (addFlagsPermission.current === true) return;

        addFlagsPermission.current = true;
        setPermissionFlags(true);
        const InVal = [valueGroupId, data.id, data.work_status === '1' ? '0' : '1'];
        sendRequest(serviceList.processGroupUser, InVal, permissionResult, true, timeOutFunctPermission, 40000);
    };

    const permissionResult = (reqInfoMap, message) => {
        setPermissionFlags(false);
        addFlagsPermission.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            getDataGroupPermissions(valueGroupId);
        }
    };

    const timeOutFunctPermission = (reqInfo) => {
        setPermissionFlags(false);
        addFlagsPermission.current = false;
        toast.error(t('error.time_out'));
    };

    useEffect(() => {
        setTimeout(() => {
            getDataGroupPermissions(valueGroupId);
        }, 700);
    }, [valueGroupId, listUser]);

    const getDataGroupPermissions = (groupId) => {
        if (getRefGroupPermissions.current) {
            return;
        }
        getRefGroupPermissions.current = true;
        setGetFlagsGroupPermissions(false);
        const Inval = [groupId];
        sendRequest(
            serviceList.getGroupUser,
            Inval,
            getDataResultGroupPermissions,
            true,
            timeOutFunctGroupPermissions,
            40000
        );
    };

    const getDataResultGroupPermissions = (reqInfoMap, message) => {
        getRefGroupPermissions.current = false;
        setGetFlagsGroupPermissions(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            const mergedArray = listUser.map((item1) => {
                const matchingItem = data.find((item2) => item2.user_id === item1.id);
                if (matchingItem) {
                    return { ...item1, group_id: matchingItem.group_id, work_status: matchingItem.work_status };
                }
                return item1;
            });
            const workStatus = data.filter((item) => item.work_status === '1').length;
            setworkStatusCount(workStatus);
            // console.log('DataResultGroupPermissionsUser', listUser, data, mergedArray)
            setTableDataGroupPermissions(mergedArray);
            // console.log('=====',  message.proc_data)
        }
        // setLoading(false);
    };

    const timeOutFunctGroupPermissions = (reqInfo) => {
        getRefGroupPermissions.current = false;
        setGetFlagsGroupPermissions(false);
        toast.error(t('error.time_out'));
        // setLoading(false);
    };

    const visibleRows = tableDataGroupPermissions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Paper sx={{ width: '100%', mb: 2 }}>
                    <UserListToolbar getValue={searchValue} />
                    {workStatusCount > 0 && (
                        <Typography variant="subtitle1" component="div" padding={0}>
                            {workStatusCount} selected
                        </Typography>
                    )}
                    <Loader loading={getFlags || getFlagsGroupPermissions} />
                    <TableContainer>
                        <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={'small'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        {/* <Checkbox
                                        indeterminate={numSelected > 0 && numSelected < rowCount}
                                        checked={rowCount > 0 && numSelected === rowCount}
                                        onChange={onSelectAllClick}
                                        inputProps={{
                                        'aria-label': 'select all desserts',
                                        }}
                                    /> */}
                                    </TableCell>
                                    {headCells.map((headCell) => (
                                        <TableCell
                                            key={headCell.id}
                                            align={headCell.numeric ? 'right' : 'left'}
                                            padding={headCell.disablePadding ? 'none' : 'normal'}
                                        >
                                            {headCell.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {visibleRows.map((row, index) => (
                                    <EnhancedTableRow
                                        key={row.id}
                                        row={row}
                                        isSelected={row?.work_status === '1' ? true : false}
                                        labelId={`enhanced-table-checkbox-${index}`}
                                        handleClick={handleClick}
                                        isDisabled={
                                            user.current?.group_user !== '1' &&
                                            screenPermissions.current?.search_permission === '1' &&
                                            screenPermissions.current?.insert_permission !== '1' &&
                                            screenPermissions.current?.update_permission !== '1'
                                                ? true
                                                : false
                                        }
                                    />
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10]}
                        component="div"
                        count={searchValueDeboun.current ? listUser.length : total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </Box>
        </>
    );
};

export default TablePermissionUser;
